import { render, staticRenderFns } from "./ListKlaimCCPp.vue?vue&type=template&id=3c381e1e&"
import script from "./ListKlaimCCPp.vue?vue&type=script&lang=js&"
export * from "./ListKlaimCCPp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports